import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

// import Home from '@/views/Home/HomeView.vue';
// const Home = () => import('@/views/Home/HomeView.vue');
// import Register from '@/views/Auth/RegisterView.vue'

// import Login from '@/views/Auth/LoginView.vue';
const Login = () => import('@/views/Auth/LoginView.vue');
// import Logout from '@/views/Auth/LogoutView.vue';
// const Logout = () => import('@/views/Auth/LogoutView.vue');

const ResetPassword = () => import('@/views/Auth/ResetPasswordView.vue');

// import Dashboard from '@/views/Dashboard/DashboardView.vue';
const Dashboard = () => import('@/views/Dashboard/DashboardView.vue');
// import Benutzer from '@/views/Dashboard/BenutzerView.vue';
const Benutzer = () => import('@/views/Dashboard/BenutzerView.vue');

// import Unternehmen from '@/views/Dashboard/Unternehmen/UnternehmenView.vue';
const Unternehmen = () => import('@/views/Dashboard/Unternehmen/UnternehmenView.vue');
// import DetailsUnternehmen from '@/views/Dashboard/Unternehmen/DetailsUnternehmenView.vue';
const DetailsUnternehmen = () => import('@/views/Dashboard/Unternehmen/DetailsUnternehmenView.vue');
// import EditUnternehmen from '@/views/Dashboard/Unternehmen/EditUnternehmenView.vue';
const EditUnternehmen = () => import('@/views/Dashboard/Unternehmen/EditUnternehmenView.vue');
// import UnternehmenSettings from '@/views/Dashboard/Unternehmen/UnternehmenSettingsView.vue';
const UnternehmenSettings = () => import('@/views/Dashboard/Unternehmen/UnternehmenSettingsView.vue');
// import UnternehmenUmfrage from '@/views/Dashboard/Unternehmen/Umfrage/UnternehmenUmfrageView.vue';
const UnternehmenUmfrage = () => import('@/views/Dashboard/Unternehmen/Umfrage/UnternehmenUmfrageView.vue');
// import UmfrageTeilnehmer from '@/views/Dashboard/Unternehmen/Umfrage/UmfrageTeilnehmerView.vue';
const UmfrageTeilnehmer = () => import('@/views/Dashboard/Unternehmen/Umfrage/UmfrageTeilnehmerView.vue');
// import UmfrageERNA from '@/views/Dashboard/Unternehmen/Umfrage/UmfrageERNAView.vue';
const UmfrageERNA = () => import('@/views/Dashboard/Unternehmen/Umfrage/UmfrageERNAView.vue');
// import UmfrageLongList from '@/views/Dashboard/Unternehmen/Umfrage/UmfrageLongListView.vue';
const UmfrageLongList = () => import('@/views/Dashboard/Unternehmen/Umfrage/UmfrageLongListView.vue');
// import EditUmfrageLongList from '@/views/Dashboard/Unternehmen/Umfrage/EditUmfrageLongListView.vue';
const EditUmfrageLongList = () => import('@/views/Dashboard/Unternehmen/Umfrage/EditUmfrageLongListView.vue');
// import UmfrageStakeholderZuordnung from '@/views/Dashboard/Unternehmen/Umfrage/UmfrageStakeholderZuordnungView.vue';
// const UmfrageStakeholderZuordnung = () => import('@/views/Dashboard/Unternehmen/Umfrage/UmfrageStakeholderZuordnungView.vue');
// import EditUmfrageStakeholderZuordnung from '@/views/Dashboard/Unternehmen/Umfrage/EditUmfrageStakeholderZuordnungView.vue';
const EditUmfrageStakeholderZuordnung = () => import('@/views/Dashboard/Unternehmen/Umfrage/EditUmfrageStakeholderZuordnungView.vue');
// import SelectUnternehmensthemen from '@/views/Dashboard/Unternehmen/Umfrage/SelectUnternehmensthemen.vue';
const SelectUnternehmensthemen = () => import('@/views/Dashboard/Unternehmen/Umfrage/SelectUnternehmensthemen.vue');
// import EditThemenBewertungInsideOut from '@/views/Dashboard/Unternehmen/Umfrage/InsideOut/EditThemenBewertungInsideOutView.vue';
const EditThemenBewertungInsideOut = () => import('@/views/Dashboard/Unternehmen/Umfrage/InsideOut/EditThemenBewertungInsideOutView.vue');
// import EditInsideOutThemenPriorisierung from '@/views/Dashboard/Unternehmen/Umfrage/InsideOut/EditInsideOutThemenPriorisierungView.vue';
const EditInsideOutThemenPriorisierung = () => import('@/views/Dashboard/Unternehmen/Umfrage/InsideOut/EditInsideOutThemenPriorisierungView.vue');
// import EditThemenBewertungOutsideIn from '@/views/Dashboard/Unternehmen/Umfrage/OutsideIn/EditThemenBewertungOutsideInView.vue';
const EditThemenBewertungOutsideIn = () => import('@/views/Dashboard/Unternehmen/Umfrage/OutsideIn/EditThemenBewertungOutsideInView.vue');
// import EditOutsideInThemenPriorisierung from '@/views/Dashboard/Unternehmen/Umfrage/OutsideIn/EditOutsideInThemenPriorisierungView.vue';
const EditOutsideInThemenPriorisierung = () => import('@/views/Dashboard/Unternehmen/Umfrage/OutsideIn/EditOutsideInThemenPriorisierungView.vue');
// import UnternehmenUmfrageErgebnis from '@/views/Dashboard/Unternehmen/Umfrage/UnternehmenUmfrageErgebnisView.vue';
const UnternehmenUmfrageErgebnis = () => import('@/views/Dashboard/Unternehmen/Umfrage/UnternehmenUmfrageErgebnisView.vue');
// import BewertungTeilnehmer from '@/views/Dashboard/Unternehmen/Umfrage/BewertungTeilnehmerView.vue';
const BewertungTeilnehmer = () => import('@/views/Dashboard/Unternehmen/Umfrage/BewertungTeilnehmerView.vue');
// import UmfrageAuswertungLongList from '@/views/Dashboard/Unternehmen/Umfrage/UmfrageAuswertungLongListView.vue';
const UmfrageAuswertungLongList = () => import('@/views/Dashboard/Unternehmen/Umfrage/UmfrageAuswertungLongListView.vue');

// import Fragenkatalog from '@/views/Dashboard/Fragenkatalog/FragenkatalogView.vue';
const Fragenkatalog = () => import('@/views/Dashboard/Fragenkatalog/FragenkatalogView.vue');
// import DetailsFragenkatalog from '@/views/Dashboard/Fragenkatalog/DetailsFragenkatalogView.vue';
const DetailsFragenkatalog = () => import('@/views/Dashboard/Fragenkatalog/DetailsFragenkatalogView.vue');
// import EditFragenkatalog from '@/views/Dashboard/Fragenkatalog/EditFragenkatalogView.vue';
const EditFragenkatalog = () => import('@/views/Dashboard/Fragenkatalog/EditFragenkatalogView.vue');

// import Unternehmensthemen from '@/views/Dashboard/Unternehmensthemen/UnternehmensthemenView.vue';
const Unternehmensthemen = () => import('@/views/Dashboard/Unternehmensthemen/UnternehmensthemenView.vue');
// import DetailsUnternehmensthema from '@/views/Dashboard/Unternehmensthemen/DetailsUnternehmensthemaView.vue';
const DetailsUnternehmensthema = () => import('@/views/Dashboard/Unternehmensthemen/DetailsUnternehmensthemaView.vue');
// import EditUnternehmensthema from '@/views/Dashboard/Unternehmensthemen/EditUnternehmensthemaView.vue';
const EditUnternehmensthema = () => import('@/views/Dashboard/Unternehmensthemen/EditUnternehmensthemaView.vue');

// import Stakeholder from '@/views/Dashboard/Stakeholder/StakeholderView.vue';
const Stakeholder = () => import('@/views/Dashboard/Stakeholder/StakeholderView.vue');
// import DetailsStakeholder from '@/views/Dashboard/Stakeholder/DetailsStakeholderView.vue';
const DetailsStakeholder = () => import('@/views/Dashboard/Stakeholder/DetailsStakeholderView.vue');
// import EditStakeholder from '@/views/Dashboard/Stakeholder/EditStakeholderView.vue';
const EditStakeholder = () => import('@/views/Dashboard/Stakeholder/EditStakeholderView.vue');

// import Umfrage from '@/views/Umfrage/UmfrageView.vue';
const Umfrage = () => import('@/views/Umfrage/UmfrageView.vue');
// import BewertungUmfrage from '@/views/Umfrage/BewertungUmfrage.vue';
const BewertungUmfrage = () => import('@/views/Umfrage/BewertungUmfrage.vue');

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/start',
  //   name: 'Home',
  //   component: Home,
  // },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  // {
  //   path: '/logout',
  //   name: 'Logout',
  //   component: Logout,
  // },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    props: (route) => ({ userId: route.query.userId, token: route.query.token }),
  },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: Register
  // },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
  },

  //#region Fragenkatalog
  {
    path: '/dashboard/fragenkatalog',
    name: 'Fragenkatalog',
    component: Fragenkatalog,
  },
  {
    path: '/dashboard/fragenkatalog/details/:fragenkatalogid',
    name: 'DetailsFragenkatalog',
    component: DetailsFragenkatalog,
    props: true,
  },
  {
    path: '/dashboard/fragenkatalog/edit',
    name: 'EditFragenkatalog',
    component: EditFragenkatalog,
    props: (route) => ({ fragenkatalogid: route.query.fragenkatalogid }),
  },
  //#endregion

  //#region Unternehmensthemen
  {
    path: '/dashboard/unternehmensthemen',
    name: 'Unternehmensthemen',
    component: Unternehmensthemen,
  },
  {
    path: '/dashboard/unternehmensthema/details/:unternehmensthemaid',
    name: 'DetailsUnternehmensthema',
    component: DetailsUnternehmensthema,
    props: true,
  },
  {
    path: '/dashboard/unternehmensthema/edit',
    name: 'EditUnternehmensthema',
    component: EditUnternehmensthema,
    props: (route) => ({ unternehmensthemaid: route.query.unternehmensthemaid, unternehmenguid: route.query.unternehmenguid }),
  },
  //#endregion

  //#region Stakeholder
  {
    path: '/dashboard/stakeholder',
    name: 'Stakeholder',
    component: Stakeholder,
  },
  {
    path: '/dashboard/stakeholder/details/:stakeholderid',
    name: 'DetailsStakeholder',
    component: DetailsStakeholder,
    props: true,
  },
  {
    path: '/dashboard/stakeholder/edit',
    name: 'EditStakeholder',
    component: EditStakeholder,
    props: (route) => ({ stakeholderid: route.query.stakeholderid }),
  },
  //#endregion

  {
    path: '/dashboard/benutzer',
    name: 'Benutzer',
    component: Benutzer,
  },

  //#region Unternehmen
  {
    path: '/dashboard/unternehmen',
    name: 'Unternehmen',
    component: Unternehmen,
  },
  {
    path: '/dashboard/unternehmen/:guid',
    name: 'DetailsUnternehmen',
    component: DetailsUnternehmen,
    props: true,
  },
  {
    path: '/dashboard/unternehmen/edit',
    name: 'EditUnternehmen',
    component: EditUnternehmen,
    props: (route) => ({ unternehmenguid: route.query.unternehmenguid }),
  },
  {
    path: '/dashboard/unternehmen/:guid/settings',
    name: 'UnternehmenSettings',
    component: UnternehmenSettings,
    props: true,
  },
  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid',
    name: 'UnternehmenUmfrage',
    component: UnternehmenUmfrage,
    props: true,
  },
  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/unternehmensthemen',
    name: 'SelectUnternehmensthemen',
    component: SelectUnternehmensthemen,
    props: true,
  },
  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/teilnehmer',
    name: 'UmfrageTeilnehmer',
    component: UmfrageTeilnehmer,
    props: true,
  },
  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/erna',
    name: 'UmfrageERNA',
    component: UmfrageERNA,
    props: true,
  },
  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/auswertung/longlist',
    name: 'UmfrageAuswertungLongList',
    component: UmfrageAuswertungLongList,
    props: true,
  },
  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/longlist',
    name: 'UmfrageLongList',
    component: UmfrageLongList,
    props: true,
  },
  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/longlist/edit',
    name: 'EditUmfrageLongList',
    component: EditUmfrageLongList,
    props: true,
  },
  // {
  //   path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/stakeholder',
  //   name: 'UmfrageStakeholderZuordnung',
  //   component: UmfrageStakeholderZuordnung,
  //   props: true,
  // },
  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/stakeholder/edit',
    name: 'EditUmfrageStakeholderZuordnung',
    component: EditUmfrageStakeholderZuordnung,
    props: true,
  },

  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/bewertung/teilnehmer',
    name: 'BewertungTeilnehmer',
    component: BewertungTeilnehmer,
    props: true,
  },

  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/bewertung/edit/insideout',
    name: 'EditThemenBewertungInsideOut',
    component: EditThemenBewertungInsideOut,
    props: true,
  },
  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/bewertung/edit/insideout/priorisierung',
    name: 'EditInsideOutThemenPriorisierung',
    component: EditInsideOutThemenPriorisierung,
    props: true,
  },
  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/bewertung/edit/outsidein',
    name: 'EditThemenBewertungOutsideIn',
    component: EditThemenBewertungOutsideIn,
    props: true,
  },
  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/bewertung/edit/outsidein/priorisierung',
    name: 'EditOutsideInThemenPriorisierung',
    component: EditOutsideInThemenPriorisierung,
    props: true,
  },
  {
    path: '/dashboard/unternehmen/:unternehmenguid/umfrage/:umfrageguid/ergebnis',
    name: 'UnternehmenUmfrageErgebnis',
    component: UnternehmenUmfrageErgebnis,
    props: true,
  },
  //#endregion

  //#region Umfragen
  // {
  //   path: '/umfrage',
  //   name: 'Umfrage',
  //   component: Umfrage,
  // },

  {
    path: '/themen/unternehmen/:unternehmenguid/umfrage/:umfrageguid/teilnehmer/:teilnehmerguid',
    name: 'Umfrage',
    component: Umfrage,
    props: true,
  },

  {
    path: '/bewertung/unternehmen/:unternehmenguid/umfrage/:umfrageguid/teilnehmer/:teilnehmerguid',
    name: 'BewertungUmfrage',
    component: BewertungUmfrage,
    props: true,
  },
  //#endregion
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

import { useStore } from '@/store';

router.beforeEach((to, from, next) => {
  // const publicPages = ['/start', '/register', '/login', '/logout', '/umfrage'];
  const store = useStore();
  let availablePages = store.getters.publicPages;

  const authUser = store.getters.authUser;

  if (authUser != null && authUser.benutzer.benutzerrolleId == 3) {
    availablePages = store.getters.userPages;
  } else if (authUser != null && authUser.benutzer.benutzerrolleId == 2) {
    availablePages = store.getters.beraterPages;
  } else if (authUser != null && authUser.benutzer.benutzerrolleId == 1) {
    availablePages = store.getters.adminPages;
  }

  // console.log(availablePages);

  // const hasAccess = !availablePages.includes(to.name as string);
  if (availablePages.includes(to.name as string)) {
    // console.log('available');
    next();
  } else if (from.name != null) {
    // console.log('return to ' + (from.name as string));
    next(from);
  } else {
    // console.log('return to Home');
    next({ name: 'Login' });
  }

  // next();
});

export default router;
